import React, { useState, useEffect } from "react";
import {
  Container,
  Box,
  TextField,
  Button,
  Typography,
  Link,
} from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { backendUrl } from "../utils/urlHelper";
import { isLoggedIn } from "../utils/authHelper";

const LoginPage = () => {
  const [mobileNumber, setMobileNumber] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const loggedIn = isLoggedIn();

  useEffect(() => {
    if (loggedIn) {
      const user = localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user"))
        : {};
      if (user?.role == "admin" || user?.role == "manager") {
        navigate("/admin/home");
      } else {
        navigate("/teacher/home");
      }
    }
  }, []);

  useEffect(() => {
    const resetPasswordFlow = searchParams.get("resetPassword") === "success";
    if (resetPasswordFlow) {
      setError("Please login with new password");
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!mobileNumber || !password) {
      setError("Please provide username and password");
      return;
    }

    try {
      const response = await axios.post(backendUrl + "/api/auth/login", {
        username: mobileNumber,
        password: password,
      });
      if (response?.data?.user?.mustChangePassword) {
        navigate("/reset-password");
        return;
      }
      // Store token in localStorage
      localStorage.setItem("token", response.data.token);
      localStorage.setItem("user", JSON.stringify(response?.data?.user));

      if (
        response?.data?.user?.role == "admin" ||
        response?.data?.user?.role == "manager"
      ) {
        navigate("/admin/home");
      } else {
        navigate("/teacher/home");
      }
    } catch (err) {
      if (err.response?.data?.mustChangePassword) {
        navigate("/reset-password");
      }
      setError(
        err.response?.data?.message || "Login failed. Please try again."
      );
    }
  };

  const goToHomePage = () => {
    navigate("/");
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Box
        component="form"
        onSubmit={handleLogin}
        sx={{
          width: "100%",
          padding: 3,
          borderRadius: 2,
          boxShadow: 3,
          backgroundColor: "white",
        }}
      >
        <Typography
          className="text-blue-900"
          variant="h5"
          sx={{ textAlign: "center", mb: 3, mt: 1 }}
        >
          {" "}
          JASS Admissions Login
        </Typography>
        {error && (
          <Typography sx={{ my: 1 }} color="error">
            {error}
          </Typography>
        )}
        <TextField
          label="Mobile Number"
          type="tel"
          variant="outlined"
          fullWidth
          value={mobileNumber}
          onChange={(e) => setMobileNumber(e.target.value)}
          sx={{ marginBottom: 2 }}
        />
        <TextField
          label="Password"
          type="password"
          variant="outlined"
          fullWidth
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          sx={{ marginBottom: 3 }}
        />
        <Button
          type="submit"
          variant="contained"
          fullWidth
          sx={{
            backgroundColor: "#3B82F6", // Tailwind blue-500 equivalent
            color: "white",
            padding: "0.75rem",
            fontWeight: "bold",
            fontSize: "1rem",
          }}
          onClick={handleLogin}
        >
          Login
        </Button>

        <Button
          variant="outlined"
          fullWidth
          onClick={() => navigate("/reset-password")}
          sx={{
            marginTop: 2,
            backgroundColor: "#eeeeee",
            textTransform: "none",
            border: "none",
            fontSize: "1rem",
            padding: "0.75rem",
          }}
        >
          Reset Password
        </Button>

        <Button
          variant="outlined"
          fullWidth
          onClick={goToHomePage}
          sx={{
            marginTop: 1,
            backgroundColor: "#eeeeee",
            textTransform: "none",
            border: "none",
            fontSize: "1rem",
            padding: "0.75rem",
          }}
        >
          Back to Home
        </Button>
      </Box>
    </Container>
  );
};

export default LoginPage;
